// @flow

export default class TextFormatter {
    static seconds(time: number, hideEmptyHours?: boolean): string {
        hideEmptyHours = hideEmptyHours || false;

        const duration = new Date(time * 1000).toISOString().slice(-13, -5);
        if (hideEmptyHours && duration.match(/^0{2}/)) {
            return duration.slice(3);
        }
        return duration;
    }

    static dateTime(date: Date = new Date()) {
        const isCurrentYear = date.getFullYear() === (new Date()).getFullYear();

        let formatOptions = {
            month: 'short',
            day: 'numeric',
            hour: 'numeric',
            minute: 'numeric',
            second: 'numeric'
        };
        if(!isCurrentYear) {
            formatOptions['year'] = 'numeric';
        }


        return date.toLocaleString('default', formatOptions);
    }
}



// WEBPACK FOOTER //
// ./src/app/util/TextFormatter.js